.assetsList {
  max-height: 100%;
  overflow: auto;
}

.item {
  color: inherit;
  position: relative;
  cursor: pointer;
  display: flex;
  gap: var(--space-m);
  width: 100%;
  padding: var(--space-s);
  border-radius: var(--border-radius-xs);
  align-items: center;

  &:nth-child(odd) {
    background-color: var(--color-body);
  }
}

.thumbnail {
  max-width: 120px;
  max-height: 120px;
}

.details {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  flex-grow: 1;
  padding: var(--space-l) 0;
}

.title {
  font-weight: var(--font-weight-bold);
}

.subtitle {
  display: block;
  font-size: 0.8em;
}

.muted {
  text-transform: uppercase;
  display: block;
  color: var(--color-accent-1);
  font-size: 0.8em;
}
